var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperiencesnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.9982C0 6.26723 6.26723 0 13.9982 0C21.7293 0 27.9965 6.26723 27.9965 13.9982C27.9965 21.7293 21.7293 27.9965 13.9982 27.9965C6.26723 27.9965 0 21.7293 0 13.9982Z",
    fill: "rgb(2, 131, 131)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3241 18.6622V9.33432C16.3241 9.02508 16.2012 8.72851 15.9826 8.50984C15.7639 8.29118 15.4673 8.16833 15.1581 8.16833H12.8261C12.5169 8.16833 12.2203 8.29118 12.0017 8.50984C11.783 8.72851 11.6602 9.02508 11.6602 9.33432V18.6622",
    stroke: "white",
    strokeWidth: 1.16598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.656 10.5002H9.32809C8.68414 10.5002 8.16211 11.0223 8.16211 11.6662V17.4961C8.16211 18.1401 8.68414 18.6621 9.32809 18.6621H18.656C19.2999 18.6621 19.8219 18.1401 19.8219 17.4961V11.6662C19.8219 11.0223 19.2999 10.5002 18.656 10.5002Z",
    stroke: "white",
    strokeWidth: 1.16598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9918,
    height: 13.9918,
    fill: "white",
    transform: "translate(6.99609 7.00232)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiencesnew);
export default __webpack_public_path__ + "static/media/Experiencesnew.ea56270dc32b2ac325b21f749fab8129.svg";
export { ForwardRef as ReactComponent };